import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable} from 'rxjs';
import {User} from '../models/user.model';
import {catchError, map} from 'rxjs/operators';
import {throwError } from 'rxjs'; // only way to ge throwError to work.
import { GlobalFunctionsService } from './global-functions.service';



@Injectable()
export class UserService2 {

  constructor(private httpService: HttpClient, public gfunc: GlobalFunctionsService) {
  };

  public getUser(id: number): Observable<User> {
    return this.httpService.get<User>(`${this.gfunc.sopNodeURL}/user/${id}`).pipe(
      map(data => new User().deserialize(data)),
      catchError(() => throwError('User not found'))
    );
  }

  public getAllUsers(): Observable<User[]> {
    return this.httpService.get<User[]>(`${this.gfunc.sopNodeURL}/users`).pipe(
      map(data => data.map(data => new User().deserialize(data)))
    );
  }
}